import React, { useContext } from 'react';
import { CustomersContext, ICustomersContext } from '../../../customersState/customersContext';
import { EntityStatus } from 'types';
import { useTranslation } from 'react-i18next';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { Icon, IconName } from 'components/Icon/Icon';

export const ResetBtn: React.FC = () => {
	const { resetSelectedControls, searchString, status, selectedClientType } =
		useContext<ICustomersContext>(CustomersContext);
	const { t } = useTranslation('listing');

	const hasActiveFilters = !!searchString || !!selectedClientType || status !== EntityStatus.Active;

	return (
		<NewButton
			variant="outline"
			size="small"
			icon={true}
			iconLeft={<Icon name={IconName.refresh} size="lg" />}
			disabled={!hasActiveFilters}
			ariaLabel={t('resetButton')}
			testId="ResetBtn"
			onClick={resetSelectedControls}
		/>
	);
};
